import { Component } from '@angular/core';
import { PssLoadingComponent } from '../../../../tools/template/pss/pss-loading/pss-loading.component';
import { InputComponent } from '../../../../tools/forms/input/input.component';
import { FormsModule } from '@angular/forms';
import {
  ApiResponseManualPlateCorrection,
  ParkingTransactionEVDto,
  EvChargerHistory,
  SendManualPlateCorrectionPayload,
} from '../../../../core/models/ev.model';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../../core/services/api.service';
import { ToastService } from 'angular-toastify';
import { ApiHandlerService } from '../../../../tools/services/api/handler-api/apiHandler.service';
import { CookieService } from 'ngx-cookie-service';
import { TableComponent } from "../../../../tools/table/table.component";

@Component({
  selector: 'app-parking-transaction-ev',
  imports: [PssLoadingComponent, InputComponent, CommonModule, FormsModule, TableComponent],
  templateUrl: './parking-transaction-ev.component.html',
  styleUrl: './parking-transaction-ev.component.css',
})
export class ParkingTransactionEvComponent {
  isLoading: boolean = false;

  /* --- Default Function --- */
  // Table & Pagination state
  currentPage: number = 1;
  pageSize: number = 10;

  // Filters
  startDate: string = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
  endDate: string = new Date().toISOString().slice(0, 10);
  searchText: string = '';

  /* -- Data -- */
  parkingEvDto: ParkingTransactionEVDto[] = [];

  /* -- Modal EvVehicleDetail -- */
  isModalEvVehicleDetail: boolean = false;
  siteEvName: string | null = '';
  spaceName: string = '';
  licensePlate: string = '';
  historyUid: string | null = '';
  plateCorrectionPayload: SendManualPlateCorrectionPayload | null = null;

  /* --- Modal EvVehicleHistory --- */
  isModalEvVehicleHistory: boolean = false;
  evVehicleHistory: EvChargerHistory[] = [];
  evVehicleHistoryCustom: any[] = [];
  evVehicleHistoryColumns: string[] =
    [
      "ยอดค่าชาร์จ",
      "กำลังไฟฟ้า (kWh)",
      "เริ่มชาร์จ",
      "สิ้นสุดชาร์จ",
      "เวลารวม (ชั่วโมง)",
    ]
  evVehicleHistoryWhere: { column: string, type: string, function: any, btColor: string | null, btText: string }[] = [
    {
      column: "amount",
      type: "text",
      btText: "",
      function: undefined,
      btColor: null
    },
    {
      column: "chargingKwh",
      type: "text",
      btText: "",
      function: undefined,
      btColor: null
    },
    {
      column: "chargingStart",
      type: "date",
      btText: "",
      function: undefined,
      btColor: null
    },
    {
      column: "chargingEnd",
      type: "date",
      btText: "",
      function: undefined,
      btColor: null
    },
    {
      column: "time",
      type: "text",
      btText: "",
      function: undefined,
      btColor: null
    }
  ];

  constructor(
    private apiService: ApiService,
    private apiHandler: ApiHandlerService,
    private toast: ToastService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    // Initial load
    this.isLoading = true;
    this.getApiParkingTransactionEVDto();
  }

  /* --------------------------------------------- Function --------------------------------------------- */

  // --- Getters for Data Display ---
  get filteredAndPaginatedData() {
    let data = this.parkingEvDto;



    // 2. Search Filter
    if (this.searchText) {
      const search = this.searchText.toLowerCase();
      data = data.filter(item =>
        (item.licensePlate || '').toLowerCase().includes(search) ||
        (item.siteEv || '').toLowerCase().includes(search) ||
        (item.spaceCode || '').toLowerCase().includes(search) ||
        (item.siteName || '').toLowerCase().includes(search)
      );
    }

    // 3. Sort (Optional - by enterAt desc or id desc)
    data.sort((a, b) => b.id - a.id);

    // 4. Pagination
    const start = (this.currentPage - 1) * this.pageSize;
    return data.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    let data = this.parkingEvDto;



    if (this.searchText) {
      const search = this.searchText.toLowerCase();
      data = data.filter(item =>
        (item.licensePlate || '').toLowerCase().includes(search) ||
        (item.siteEv || '').toLowerCase().includes(search) ||
        (item.spaceCode || '').toLowerCase().includes(search) ||
        (item.siteName || '').toLowerCase().includes(search)
      );
    }

    if (this.pageSize === 0) return 0;
    return Math.ceil(data.length / this.pageSize);
  }

  get pagesArray() {
    const total = this.totalPages;
    const maxVisibleButtons = 5;

    let startPage = Math.max(1, this.currentPage - 2);
    let endPage = Math.min(total, startPage + maxVisibleButtons - 1);

    if (endPage - startPage < maxVisibleButtons - 1) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  // --- Pagination Actions ---
  setPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  onPageSizeChange(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.pageSize = Number(element.value);
    this.currentPage = 1;
  }

  // --- Filter Actions ---
  onSearch(value: string) {
    this.searchText = value;
    this.currentPage = 1;
  }

  onClickSearch() {
    this.currentPage = 1;
  }

  onRefresh() {
    this.searchText = '';
    this.startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
    this.endDate = new Date().toISOString().slice(0, 10);
    this.currentPage = 1;
    this.isLoading = true;
    this.getApiParkingTransactionEVDto();
  }

  // --- Helpers ---
  calHours(totalTime: number) {
    const hours = Math.floor(totalTime / 60);
    const minutes = totalTime % 60;
    return { hours, minutes };
  }

  /* --- Modal Actions --- */
  onClickEditEvVehicleDetail(evVehicleDetail: ParkingTransactionEVDto) {
    this.spaceName = evVehicleDetail.spaceCode;
    this.siteEvName = evVehicleDetail.siteEv;
    this.licensePlate = evVehicleDetail.licensePlate;
    this.historyUid = evVehicleDetail.historyUuid;
    this.onOpenModalEvVehicleDetail();
  }

  onClickHistoryEvVehicleDetail(evVehicleDto: ParkingTransactionEVDto) {
    this.getApiEvVehicleHistory(evVehicleDto.id);
  }

  /* --- Modal EvVehicleDetail --- */
  onOpenModalEvVehicleDetail() {
    this.isModalEvVehicleDetail = true;
  }
  onCloseModalEvVehicleDetail() {
    this.isModalEvVehicleDetail = false;
    this.resetModalEvVehicleDetail();
    this.getApiParkingTransactionEVDto();
  }
  resetModalEvVehicleDetail() {
    this.isModalEvVehicleDetail = false;
    this.siteEvName = null;
    this.spaceName = '';
    this.licensePlate = '';
    this.historyUid = null;
  }
  onConfirmSendManualPlateCorrection(licensePlate: string) {
    if (!this.siteEvName || !this.spaceName || !this.licensePlate) {
      this.toast.error('กรุณากรอกข้อมูลให้ครบ');
      return;
    }
    this.plateCorrectionPayload = {
      siteEvName: this.siteEvName,
      spaceName: this.spaceName,
      licensePlate: licensePlate,
      historyUid: this.historyUid || '',
      userId: Number(this.cookieService.get('user_id')),
    };
    this.sentApiManualPlateCorrection(this.plateCorrectionPayload);
  }

  /* --- Modal EvVehicleHistory --- */
  onOpenModalEvVehicleHistory() {
    this.isModalEvVehicleHistory = true;
  }
  onCloseModalEvVehicleHistory() {
    this.isModalEvVehicleHistory = false;
  }


  /* ----------------------------------------------- API ----------------------------------------------- */
  getApiParkingTransactionEVDto() {
    // Note: If the API supports date filtering params, we should pass them here.
    // For now, consistent with previous implementation, we fetch all and filter client-side?
    // Or if `getRegisterParkingDetail` accepted dates, maybe this one should too?
    // The previous code `getApiParkingTransactionEVDto` took no args and fetched all.
    // I will stick to fetching all and filtering client side as requested to match logic style, unless API service has updated method.
    // However, if the list is huge, this is bad. But based on `RegisterParkingComponent` using `getRegisterParkingDetail(start, end)`,
    // checking `ApiService` might be wise. But user asked to match "functions filtering page".
    // I'll stick to client side filtering of the fetched list for now as the `getParkingTransactionEVDto` in previous thought didn't show args.

    this.apiHandler.handleApi(this.apiService.getParkingTransactionEVDto(), {
      logLabel: 'getApiParkingTransactionEVDto',
      isConsoleLog: true,
      loading: (loading: boolean) => (this.isLoading = loading),
      success: (response: ParkingTransactionEVDto[]) => {
        this.parkingEvDto = response;
        this.currentPage = 1;
      },
      error: (error) => {
        this.toast.error('เกิดข้อผิดพลาดในการดึงข้อมูล');
      },
    });
  }

  // Modal EvVehicleDetail
  sentApiManualPlateCorrection(payload: SendManualPlateCorrectionPayload) {
    this.apiHandler.handleApi(
      this.apiService.sentManualPlateCorrection(payload),
      {
        logLabel: 'sentApiSendManualPlateCorrection',
        isConsoleLog: true,
        loading: (loading: boolean) => (this.isLoading = loading),
        success: (response: ApiResponseManualPlateCorrection) => {
          if (response.status == 'ok') {
            this.toast.success('แก้ไขสำเร็จเรียบร้อย');
            this.onCloseModalEvVehicleDetail();
          } else {
            if (response.error?.message) {
              this.toast.warn(response.error?.message);
            } else {
              this.toast.error('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
            }
          }
        },
        error: (error) => {
          this.toast.error('เกิดข้อผิดพลาดในการดึงข้อมูล');
        },
      }
    );
  }

  // Modal EvVehicleHistory
  getApiEvVehicleHistory(evId: number) {
    this.apiHandler.handleApi(
      this.apiService.getChargerHistoryById(evId),
      {
        logLabel: 'getApiEvVehicleHistory',
        isConsoleLog: true,
        loading: (loading: boolean) => (this.isLoading = loading),
        success: (response: EvChargerHistory[]) => {
          this.evVehicleHistory = response;
          // สร้างข้อมูลสำหรับเวลา
          this.evVehicleHistoryCustom = this.evVehicleHistory.map((history) =>
          (
            {
              ...history,
              "time": Math.floor(history.totalTime / 60) + " ชั่วโมง " + history.totalTime % 60 + " นาที",

            }
          )
          );
          this.onOpenModalEvVehicleHistory();
        },
        error: (error) => {
          this.toast.error('เกิดข้อผิดพลาดในการดึงข้อมูล');
        },
      }
    );
  }
}
